import {
  anatomiaIcon,
  bioquimicaIcon,
  DnaIcon,
  embriologiaIcon,
  farmacologiaIcon,
  fisiologiaIcon,
  geneticaIcon,
  histologiaIcon,
  imunologiaIcon,
  microbiologiaIcon,
  parasitologiaIcon,
  patologiaIcon,
} from 'morpheus-ui';
import { Permissions } from '../accessControl/permissions';
import { iOption } from '../components/atoms/Select';

export const DISCIPLINES = [
  {
    id: '67a649c2b5df925acf3d5ae2',
    slug: 'embriologia-superior',
    name: 'Embriologia',
    icon: embriologiaIcon,
    permission: Permissions.DISCIPLINAS_EMBRIOLOGIA,
    order: 6
  },
  {
    id: '67a649d154e8a222fe439241',
    slug: 'farmacologia-superior',
    name: 'Farmacologia',
    icon: farmacologiaIcon,
    permission: Permissions.DISCIPLINAS_FARMACOLOGIA,
    order: 11
  },
  {
    id: '67a649de53385405e8347d57',
    slug: 'fisiologia-superior',
    name: 'Fisiologia Humana',
    icon: fisiologiaIcon,
    permission: Permissions.DISCIPLINAS_FISIOLOGIA,
    disabled: false,
    order: 4
  },
  {
    id: '67a649e94a2955b1abd77d7a',
    slug: 'genetica-superior',
    name: 'Genética',
    icon: geneticaIcon,
    permission: Permissions.DISCIPLINAS_GENETICA,
    disabled: false,
    order: 5
  },
  {
    id: '6744f2ce73342c8bdf624b31',
    slug: 'anatomia-superior',
    name: 'Anatomia Humana',
    icon: anatomiaIcon,
    permission: Permissions.DISCIPLINAS_ANATOMIA,
    disabled: false,
    order: 2
  },
  {
    id: '6744f33373342c8bdf624e8e',
    slug: 'bioquimica-superior',
    name: 'Bioquímica',
    icon: bioquimicaIcon,
      permission: Permissions.DISCIPLINAS_BIOQUIMICA,
    disabled: false,
    order: 1
  },
  {
    id: '6744f3a173342c8bdf62523c',
    slug: 'histologia-humana-superior',
    name: 'Histologia Humana',
    icon: histologiaIcon,
    permission: Permissions.DISCIPLINAS_HISTOLOGIA,
    disabled: false,
    order: 3
  },
  {
    id: '6744f40a73342c8bdf6255c0',
    slug: 'imunologia-superior',
    name: 'Imunologia',
    icon: imunologiaIcon,
    permission: Permissions.DISCIPLINAS_IMUNOLOGIA,
    disabled: false,
    order: 7
  },
  {
    id: '6744f51e73342c8bdf625ed2',
    slug: 'parasitologia-superior',
    name: 'Parasitologia',
    icon: parasitologiaIcon,
    permission: Permissions.DISCIPLINAS_PARASITOLOGIA,
    disabled: false,
    order: 9
  },
  {
    id: '6744f4c973342c8bdf625bfc',
    slug: 'patologia-superior',
    name: 'Patologia',
    icon: patologiaIcon,
    permission: Permissions.DISCIPLINAS_PATOLOGIA,
    disabled: false,
    order: 10
  },
  {
    id: '6744f47773342c8bdf625936',
    slug: 'microbiologia-superior',
    name: 'Microbiologia',
    icon: microbiologiaIcon,
    permission: Permissions.DISCIPLINAS_MICROBIOLOGIA,
    disabled: false,
    order: 8
  },
];

export const getDisciplineIcon = (disciplineSlug: string) => {
  const discipline = DISCIPLINES.find(
    (discipline) => discipline.slug === disciplineSlug
  );

  if (!discipline) return DnaIcon;

  return discipline.icon;
};

export const getDisciplineName = (disciplineSlug: string) => {
  const discipline = DISCIPLINES.find(
    (discipline) => discipline.slug === disciplineSlug
  );

  if (!discipline) {
    const simpleSlug = disciplineSlug.split('-')[0];
    const simpleDiscipline = DISCIPLINES.find(
      (discipline) => discipline.slug.split('-')[0] === simpleSlug
    );

    if (!simpleDiscipline) return disciplineSlug;

    return simpleDiscipline.name;
  }

  return discipline.name;
};

export function getDisciplineSlugByName(name: string) {
  const normalizeText = (text: string) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const cleanedName = normalizeText(name);

  const discipline = DISCIPLINES.find(
    (discipline) => normalizeText(discipline.name) === cleanedName
  );

  if (!discipline) return name;

  return discipline.slug;
}

export function getDisciplinesOptions(): iOption[] {
  return DISCIPLINES.filter((discipline) => !discipline.disabled).map((discipline) => ({
    label: discipline.name.replace('Humana', ''),
    value: discipline.slug,
  }));
}

// OLD

export const knowledgeDisciplineSlugs = [
  'linguagens-codigos-e-suas-tecnologias',
  'ciencias-humanas-e-suas-tecnologias',
  'ciencias-da-natureza-e-suas-tecnologias',
  'matematica-e-suas-tecnologias',
];

export const disciplinesWithKnowledge: { [key: string]: string } = {
  biologia: 'ciencias-da-natureza-e-suas-tecnologias',
  fisica: 'ciencias-da-natureza-e-suas-tecnologias',
  quimica: 'ciencias-da-natureza-e-suas-tecnologias',
  matematica: 'matematica-e-suas-tecnologias',
  historia: 'ciencias-humanas-e-suas-tecnologias',
  geografia: 'ciencias-humanas-e-suas-tecnologias',
  filosofia: 'ciencias-humanas-e-suas-tecnologias',
  sociologia: 'ciencias-humanas-e-suas-tecnologias',
  portugues: 'linguagens-codigos-e-suas-tecnologias',
  literatura: 'linguagens-codigos-e-suas-tecnologias',
  ingles: 'linguagens-codigos-e-suas-tecnologias',
  espanhol: 'linguagens-codigos-e-suas-tecnologias',
  interdisciplinar: 'interdisciplinar',
};

export const getKnowledgeDisciplineName = (knowledgeAreaSlug: string) => {
  switch (knowledgeAreaSlug) {
    case 'linguagens-codigos-e-suas-tecnologias':
      return 'Linguagens';
    case 'ciencias-humanas-e-suas-tecnologias':
      return 'Ciências Humanas';
    case 'ciencias-da-natureza-e-suas-tecnologias':
      return 'Ciências da Natureza';
    case 'matematica-e-suas-tecnologias':
      return 'Matemática';
  }
};
